export default function hero( el ) {
	if ( ! el ) {
		return;
	}

	console.log( 'Hero JS loaded' );
	const slider = el.querySelector( '.b-hero-slider' );
	if ( slider ) {
		const carousel = new Flickity( slider, {
			cellAlign: 'center',
			wrapAround: true,
			pageDots: false,
			setGallerySize: true,
			autoPlay: false, // Initially disable autoplay
			prevNextButtons: false, // Disable default prev/next buttons
		} );

		// Enable autoplay after 1 second (1000ms)
		setTimeout( () => {
			carousel.options.autoPlay = 6000;
			carousel.playPlayer();
		}, 1000 );

		const carouselDot = el.querySelectorAll( '.b-hero-slider-dot' );

		// Set initial active state
		carouselDot[ 0 ].classList.add( 'is-selected' );

		// Update dots on slide change
		carousel.on( 'select', function( index ) {
			carouselDot.forEach( ( dot ) => dot.classList.remove( 'is-selected' ) );
			carouselDot[ index ].classList.add( 'is-selected' );
		} );

		// Add click handlers to dots
		carouselDot.forEach( ( dot, index ) => {
			dot.addEventListener( 'click', () => {
				carousel.select( index );
			} );
		} );

		window.addEventListener( 'resize', () => {
			carousel.resize();
		} );
	}
}
